import App from 'app/app.js';
import ProductPersonalizer from 'app/store/ProductPersonalizer.js';

var ItemService = function () {
  var self = this;
  this.selectedPkgSku;
  this.popUpAction = false;
  this.hasupsellHaveSelectedPackage = false;
  this.fromShoppingcart = false;

  this.isPersonalizerEnabled = function (item) {
    return !!item?.personalizerEnabled && item?.productPersonalizer === ProductPersonalizer.LNSSTextBasedPersonalizer;
  };

  this.isTextBasedPersonalizerEnabled = function (item) {
    return !!item.personalizerEnabled && item.productPersonalizer === ProductPersonalizer.LNSSTextBasedPersonalizer;
  };

  this.isLookSelectionAllowed = function (item) {
    return !!item.lookSelectionAllowed;
  };

  this.hasPersonalizerEnabled = function (packageBundle) {
    return R.any(self.isPersonalizerEnabled)(packageBundle.items || []);
  };

  this.hasTextBasedPersonalizerEnabled = function (packageBundle) {
    return R.any(self.isTextBasedPersonalizerEnabled)(packageBundle.items || []);
  };

  this.shoppingCartTextBasedPersonalizerEnabled = function (packageBundle) {
    return self.isTextBasedPersonalizerEnabled(packageBundle.item || []);
  };

  this.hasLookSelectionAllowed = function (packageBundle) {
    return R.any(self.isLookSelectionAllowed)(packageBundle.items || []);
  };

  this.parseItemName = function (itemName, items) {
    // \u00C0-\u00FF (Latin-1 Supplement) to cover French and Spanish
    var bracesRegex = /\((\d+)\)\s*(\d+)[xX](\d+)([\s\w\u00C0-\u00FF]*)/; // (4) 3x7 Wallets
    var hyphenRegex = /(\d+)\s*[-]\s*(\d+)[xX](\d+)([\s\w\u00C0-\u00FF]*)/; // 8 - Mignonnettes
    var bracesWithoutWidthHeightRegex = /\((\d+)\)\s*([\s\w\u00C0-\u00FF]*)/; //  (1) 8x10
    var hyphenWithoutWidthHeightRegex = /(\d+)\s*[-]\s*([\s\w\u00C0-\u00FF]*)/; //  1 - 8x10
    var bracesTextDimensionsRegex = /\((\d+)\)\s*([\s\w\u00C0-\u00FF]*)\s*(\d+)[xX](\d+)/; //  (8) Mignonnettes 2x3
    var hyphenTextDimensionsRegex = /(\d+)\s*[-]\s*([\s\w\u00C0-\u00FF]*)\s*(\d+)[xX](\d+)/; // 8 - Mignonnettes 2x3
    var doubleHyphenWithoutWidthHeightRegex = /(\d+)\s*[-]\s*([\s\w\u00C0-\u00FF]*)\s*[-]\s*([\s\w\u00C0-\u00FF]*)/; // 1 - Digital Image - Background of your choice

    var result;
    var regex;
    var countTextDimensionsFlag = false;

    try {
      if (bracesRegex.test(itemName)) {
        result = bracesRegex.exec(itemName);
        regex = bracesRegex;
      } else if (hyphenRegex.test(itemName)) {
        result = hyphenRegex.exec(itemName);
        regex = hyphenRegex;
      } else if (bracesTextDimensionsRegex.test(itemName)) {
        result = bracesTextDimensionsRegex.exec(itemName);
        regex = bracesTextDimensionsRegex;
        countTextDimensionsFlag = true;
      } else if (hyphenTextDimensionsRegex.test(itemName)) {
        result = hyphenTextDimensionsRegex.exec(itemName);
        regex = hyphenTextDimensionsRegex;
        countTextDimensionsFlag = true;
      } else if (bracesWithoutWidthHeightRegex.test(itemName)) {
        result = bracesWithoutWidthHeightRegex.exec(itemName);
        regex = bracesWithoutWidthHeightRegex;
      } else if (doubleHyphenWithoutWidthHeightRegex.test(itemName)) {
        result = doubleHyphenWithoutWidthHeightRegex.exec(itemName);
        regex = doubleHyphenWithoutWidthHeightRegex;
      } else if (hyphenWithoutWidthHeightRegex.test(itemName)) {
        result = hyphenWithoutWidthHeightRegex.exec(itemName);
        regex = hyphenWithoutWidthHeightRegex;
      }

      if (result) {
        var itemObj;
        if (result.length >= 5) {
          if (countTextDimensionsFlag) {
            itemObj = {
              count: parseInt(result[1]),
              dimensions: result[3] + 'x' + result[4],
              description: (result[2] && result[2].trim() ? result[2].trim() + ' ' : '') + result[3] + 'x' + result[4]
            };
          } else {
            itemObj = {
              count: parseInt(result[1]),
              dimensions: result[2] + 'x' + result[3],
              description: result[2] + 'x' + result[3] + (result[4] ? ' ' + result[4].trim() : '')
            };
          }
        } else if (result.length >= 3) {
          itemObj = {
            count: parseInt(result[1]),
            description: result[2].trim() + (result[3] ? ' - ' + result[3].trim() : '')
          };
        }
        var allItems = !items ? [itemObj] : items.concat(itemObj);
        return self.parseItemName(itemName.replace(regex, ''), allItems);
      } else {
        if (itemName.replace(',', '').trim().length !== 0) {
          return [
            {
              description: itemName
            }
          ];
        } else {
          return items;
        }
      }
    } catch (e) {
      return [
        {
          description: itemName
        }
      ];
    }
  };

  /**
   * Recursive method.
   * Will attempt to parse item names, will return item objects and/or if parse was successful
   *   must be in the format '(n) wxh description'
   *   examples:
   *     correct: '(1) 8x10', '(4) 3x7 Wallets', '(2) 5x7, (4) 3x7 Wallets, (8) Mignonnettes 2x3, 8 - Mignonnettes 2x3'
   *     incorrect: '(4) Variety 3x7', '2-5x7 Individuals'
   * @param itemName - item name, ex. '(1) 8x10'
   * @param items - optionally pass previously parsed items
   * @returns {{success: boolean, items: *}}
   */
  this.parseCYOPItemName = function (itemName, items) {
    var bracesRegex = /^\((\d+)\)\s*(\d+)[xX](\d+)\s*([\w\s'\-\u00C0-\u00FF]*?)(?:,\s*(.*))?$/;
    var hyphenRegex = /^(\d+)\s*[-]\s*(\d+)[xX](\d+)\s*([\w\s'\-\u00C0-\u00FF]*?)(?:,\s*(.*))?$/;
    var bracesTextDimensionsRegex =
      /^\((\d+)\)\s*([\w\s'\-\u00C0-\u00FF]*?)\s*(\d+)[xX](\d+)\s*([\w\s'\-\u00C0-\u00FF]*?)(?:,\s*(.*))?$/;
    var hyphenTextDimensionsRegex =
      /^(\d+)\s*[-]\s*([\w\s'\-\u00C0-\u00FF]*?)\s*(\d+)[xX](\d+)\s*([\w\s'\-\u00C0-\u00FF]*?)(?:,\s*(.*))?$/;
    var dimensionsDescriptionRegex = /^(\d+)[xX](\d+)\s*([\w\s'\-\u00C0-\u00FF]*?)(?:,\s*(.*))?$/;
    var bracesWithoutWidthHeightRegex = /^\((\d+)\)\s*([\w\s'\-\u00C0-\u00FF]*?)(?:,\s*(.*))?$/;
    var hyphenWithoutWidthHeightRegex = /^(\d+)\s*[-]\s*([\w\s'\-\u00C0-\u00FF]*?)(?:,\s*(.*))?$/;

    var result;
    var countTextDimensionsFlag = false;

    if (!items) {
      items = [];
    }
    itemName = itemName.trim();

    if (itemName.length === 0) {
      return items;
    }

    try {
      if (bracesRegex.test(itemName)) {
        result = bracesRegex.exec(itemName);
      } else if (hyphenRegex.test(itemName)) {
        result = hyphenRegex.exec(itemName);
      } else if (bracesTextDimensionsRegex.test(itemName)) {
        result = bracesTextDimensionsRegex.exec(itemName);
        countTextDimensionsFlag = true;
      } else if (hyphenTextDimensionsRegex.test(itemName)) {
        result = hyphenTextDimensionsRegex.exec(itemName);
        countTextDimensionsFlag = true;
      } else if (dimensionsDescriptionRegex.test(itemName)) {
        result = dimensionsDescriptionRegex.exec(itemName);
      } else if (bracesWithoutWidthHeightRegex.test(itemName)) {
        result = bracesWithoutWidthHeightRegex.exec(itemName);
      } else if (hyphenWithoutWidthHeightRegex.test(itemName)) {
        result = hyphenWithoutWidthHeightRegex.exec(itemName);
      }

      if (result) {
        var itemObj = {};
        var remainingStringForNextIteration = '';

        if (countTextDimensionsFlag) {
          itemObj.count = parseInt(result[1]);
          itemObj.dimensions = result[3] + 'x' + result[4];
          itemObj.description =
            (result[2] ? result[2].trim() + ' ' : '') +
            result[3] +
            'x' +
            result[4] +
            (result[5] ? ' ' + result[5].trim() : '');
          remainingStringForNextIteration = result[6] ? result[6].trim() : '';
        } else if (bracesRegex.test(itemName) || hyphenRegex.test(itemName)) {
          itemObj.count = parseInt(result[1]);
          itemObj.dimensions = result[2] + 'x' + result[3];
          itemObj.description = result[2] + 'x' + result[3] + (result[4] ? ' ' + result[4].trim() : '');
          remainingStringForNextIteration = result[5] ? result[5].trim() : '';
        } else if (dimensionsDescriptionRegex.test(itemName)) {
          itemObj.dimensions = result[1] + 'x' + result[2];
          itemObj.description = itemObj.dimensions + (result[3] ? ' ' + result[3].trim() : '');
          remainingStringForNextIteration = result[4] ? result[4].trim() : '';
        } else if (
          result.length >= 3 &&
          (bracesWithoutWidthHeightRegex.test(itemName) || hyphenWithoutWidthHeightRegex.test(itemName))
        ) {
          itemObj.count = parseInt(result[1]);
          itemObj.description = result[2].trim();
          remainingStringForNextIteration = result[3] ? result[3].trim() : '';
        }

        items.push(itemObj);

        remainingStringForNextIteration = remainingStringForNextIteration.replace(/^&\s*/, '');

        return this.parseCYOPItemName(remainingStringForNextIteration, items);
      } else {
        var trimmedItemName = itemName.replace(',', '').trim();
        if (trimmedItemName.length > 0) {
          items.push({ description: trimmedItemName });
        }
        return items;
      }
    } catch (e) {
      console.error('Error parsing item name:', e, 'Original item name part:', itemName);
      items.push({ description: itemName });
      return items;
    }
  };

  this.loadParsedSheets = function (orderLineDetail, isCYOP = false) {
    if (!orderLineDetail.item.parsedSheets) {
      orderLineDetail.item.parsedSheets = isCYOP
        ? this.parseCYOPItemName(orderLineDetail.item.nameDesc)
        : self.parseItemName(orderLineDetail.item.nameDesc);
    }
  };

  this.loadParsedSheetsForAll = function (orderLineDetails) {
    orderLineDetails.forEach(function (orderLineDetail) {
      if (!orderLineDetail.item.parsedSheets) {
        orderLineDetail.item.parsedSheets = self.parseItemName(orderLineDetail.item.nameDesc);
      }
    });
  };

  /*
           Remove dynamic package name which are showing when enhancements are opt out for standard packages as below in cart, review, confirmation pages.
           Ex:
            Premium - No Retouching
            Premium - No Name/Grade
            Premium - No Name/Grade & No Retouching
           Expected: Premium
         */
  this.getBasePackageNameAfterDynamicPackageNameRemoved = function (item) {
    if (item && item.skuCategory === 'PACKAGE' && item.nameDesc && item.nameDesc.includes('-')) {
      return item.nameDesc.split('-')[0].trim();
    }
    return (item && item.nameDesc) || '';
  };

  this.showCustomSheet = function (orderLineDetail, orderLine) {
    var isStandardizedPricing = orderLine && orderLine.orderable?.standardizedPricingContentZone;
    return isStandardizedPricing && orderLineDetail.item.displayGroup !== 'DG_OTHER' && !!orderLineDetail.look;
  };
  this.isModelImage = function (orderLineDetail, orderLine) {
    return (
      orderLineDetail &&
      orderLineDetail.item &&
      (orderLineDetail.item.lookSelectionAllowed || this.showCustomSheet(orderLineDetail, orderLine))
    );
  };

  this.isProductImage = function (orderLineDetail, orderLine) {
    return !this.isModelImage(orderLineDetail, orderLine);
  };
};

App.service('ItemService', [ItemService]);
